import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../app/api";

interface Props {
  txRef?: string;
  amount?: any;
  refundType?: string;
  refundReason?: string;
  tnxRef?: string;
}

export const InitiateRefund = createAsyncThunk(
  "refund/initiate",
  async (
    { txRef, amount, refundType, refundReason }: Props,
    { rejectWithValue },
  ) => {
    try {
      const response = await api.post(`/`, {
        txRef,
        amount,
        refundType,
        refundReason,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  },
);
export const getATransactionDetails = createAsyncThunk(
  "refund/get-transaction",
  async ({ tnxRef }: Props, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `nucleus/tnx/merchant/status
                `,
        {
          tnxRef,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  },
);

export const getAllRefunds = createAsyncThunk(
  "refund/get-all",
  async (
    {
      startDay,
      endDay,
      refundRef,
      status,
      amount,
      fundAmount,
      key,
      pageSize,
      business,
      pageNumber,
    }: {
      startDay?: string;
      endDay?: string;
      status?: string;
      fundAmount?: number;
      refundRef?: any;
      amount?: any;
      business?: string;
      key: string;
      pageSize?: any;
      pageNumber?: any;
    },
    { rejectWithValue },
  ) => {
    try {
      const headers = {
        "x-auth-token": key,
      };

      const response = await api.post(
        `/nucleus/refund/filter/paginated`,
        {
          startDay,
          endDay,
          refundRef,
          fundAmount,
          status,
          amount,
          pageSize,
          business,
          pageNumber,
        },
        {
          headers: headers,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  },
);

export const getRefundsFee = createAsyncThunk(
  "refund/get-fee",
  async (
    {
      currency,
      amount,
    }: {
      currency: string;
      amount: number;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await api.get(
        `/wallet/fees/get/v3?currency=${currency}&amount=${amount}&flow=MOMO_REFUND`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  },
);
